import { type VariantProps, cva } from "class-variance-authority";
import { type HTMLAttributes, type ReactNode, forwardRef } from "react";
import { cn } from "../lib/cn";

export const avatarVariants = cva(
	"inline-flex items-center justify-center rounded-full bg-muted text-mutedForeground font-medium select-none shrink-0 overflow-hidden",
	{
		variants: {
			size: {
				sm: "h-8 w-8 text-xs",
				default: "h-10 w-10 text-sm",
				lg: "h-12 w-12 text-base",
				xl: "h-16 w-16 text-lg",
			},
		},
		defaultVariants: {
			size: "default",
		},
	},
);

export interface AvatarProps
	extends HTMLAttributes<HTMLSpanElement>,
		VariantProps<typeof avatarVariants> {
	initials?: string;
	children?: ReactNode;
}

const Avatar = forwardRef<HTMLSpanElement, AvatarProps>(
	({ className, size, initials, children, ...props }, ref) => (
		<span
			ref={ref}
			className={cn(avatarVariants({ size }), className)}
			aria-hidden={!initials}
			{...props}
		>
			{children ?? (initials ? initials.slice(0, 2).toUpperCase() : null)}
		</span>
	),
);
Avatar.displayName = "Avatar";

export default Avatar;
export { Avatar };
